module.exports = __webpack_public_path__ + "images/7ce9b451b09f9b44e672c2a4c5ff6524-CYMRU_WALES_LARGE_RGB_RED_GREY.png";